<template>
  <v-row class="fill-height text-center px-3 pb-2">
    <v-col v-for="(product, i) in products" :key="i" cols="12" class="pa-0">
      <v-row class="px-3 pb-2">
        <v-col cols="12" class="pb-0">
          <v-autocomplete
            v-model="product.id"
            :items="productsToSelect[i]"
            :value="product.id"
            :label="`Producto ${i + 1}`"
            :readonly="isReadOnly || isProductDeleted(product.id)"
            :rules="[$rules.REQUIRED]"
            style="font-size: 15px"
            item-text="name"
            item-value="id"
            @change="changeProductsToSelect(i, $event)"
          />
        </v-col>
        <v-col
          v-if="
            getProductsMap[product.id] &&
            getProductsMap[product.id].attributes &&
            getProductsMap[product.id].attributes.length
          "
          cols="12"
          class="py-0"
        >
          <v-row>
            <v-col
              v-for="(attribute, attributeInd) in getProductsMap[product.id].attributes"
              :key="attribute.id"
              cols="3"
            >
              <v-select
                :value="
                  product.attributes && product.attributes[attributeInd] ? product.attributes[attributeInd].value : ''
                "
                :items="attribute.options"
                :label="attribute.name"
                :rules="[$rules.REQUIRED]"
                :readonly="isReadOnly || isProductDeleted(product.id)"
                placeholder="Seleccione"
                item-text="name"
                item-value="name"
                return-object
                @change="changeAttributeOption($event, i, attribute.id)"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4" sm="2">
          <v-text-field
            v-model.number="product.quantity"
            :rules="[$rules.NUMBER, $rules.GREATER_THAN_ZERO]"
            :readonly="isReadOnly || isProductDeleted(product.id)"
            label="Cantidad"
            placeholder="0"
            @input="updateSubtotal(i)"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model.number="product.price"
            :rules="[$rules.REQUIRED, $rules.CURRENCY, $rules.GREATER_THAN_ZERO]"
            :prefix="$currency.symbol"
            :readonly="isReadOnly || isProductDeleted(product.id)"
            label="Precio"
            placeholder="0"
            @input="updateSubtotal(i)"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            :value="$formatCurrency(product.subtotal, false)"
            :prefix="$currency.symbol"
            :readonly="true"
            label="Subtotal"
            placeholder="0"
          />
        </v-col>
        <v-col
          v-if="!isReadOnly || (getOrder && getOrder.delivery_state !== 'pedido-entregado')"
          cols="4"
          sm="1"
          class="text-right my-auto"
        >
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon small v-on="on" @click="removeProduct(i)">
                <v-icon small> far fa-trash-alt </v-icon>
              </v-btn>
            </template>
            <span>Eliminar producto</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12" class="mt-2">
          <v-divider />
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="products && products.length" cols="12" class="pa-0 pb-4">
      <v-row class="px-3">
        <v-col cols="4" sm="6" class="py-0 text-right">
          <p class="my-auto pt-5 font-weight-bold grey--text text--darken-2">Descuento:</p>
        </v-col>
        <v-col cols="4" sm="4" class="py-0">
          <v-text-field v-model.number="discountToApply" :rules="[$rules.CURRENCY]" :readonly="isReadOnly" suffix="%" />
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4" sm="6" class="py-0 text-right">
          <p class="my-auto pt-5 font-weight-bold grey--text text--darken-2">Total productos:</p>
        </v-col>
        <v-col cols="4" sm="4" class="py-0">
          <v-text-field
            :value="$formatCurrency(totalProducts, false)"
            :readonly="true"
            :prefix="$currency.symbol"
            placeholder="0"
          />
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4" sm="6" class="py-0 text-right">
          <p class="my-auto pt-5 font-weight-bold grey--text text--darken-2">Total delivery:</p>
        </v-col>
        <v-col cols="4" sm="4" class="py-0">
          <v-text-field
            :value="$formatCurrency(totalDelivery, false)"
            :readonly="true"
            :prefix="$currency.symbol"
            placeholder="0"
          />
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4" sm="6" class="py-0 text-right">
          <p class="my-auto pt-5 font-weight-bold grey--text text--darken-2">Total a pagar:</p>
        </v-col>
        <v-col cols="4" sm="4" class="py-0">
          <v-text-field
            :value="$formatCurrency(totalProducts + totalDelivery, false)"
            :readonly="true"
            :prefix="$currency.symbol"
            placeholder="0"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col v-else cols="12">
      <h5 class="font-weight-thin text--secondary">No hay productos asociados</h5>
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Products",
  props: {
    discount: {
      type: Number,
      default: 0,
    },
    products: {
      type: Array,
      required: true,
    },
    totalDelivery: {
      type: Number,
      default: 0,
    },
    action: {
      type: String,
      default: "read",
    },
  },
  data() {
    return {
      total: 0,
      totalProducts: 0,
      productsToSelect: [],
      discountToApply: null,
      resetProducts: false,
      editProducts: false,
      loadingSave: false,
    };
  },
  computed: {
    ...mapGetters(["getOrder", "getActiveProducts", "getProductsMap"]),
    isReadOnly() {
      return this.action === "read";
    },
  },
  watch: {
    products() {
      this.changeProductsToSelect();
    },
    discount(value) {
      this.discountToApply = value;
    },
    discountToApply(value) {
      this.$emit("update:discount", value || 0);
      this.totalProducts = this.total - (this.total * value) / 100;
    },
    total(value) {
      this.totalProducts = value - (value * this.discountToApply) / 100;
    },
  },
  created() {
    this.changeProductsToSelect();
    this.discountToApply = this.discount;
  },
  methods: {
    isProductDeleted(productId) {
      return this.action === "update" && productId !== "" && !this.getProductsMap[productId];
    },
    updateTotal() {
      let total = 0;

      for (let i = 0; i < this.products.length; i++) total += this.products[i].quantity * this.products[i].price;

      this.total = total;
    },
    updateSubtotal(ind) {
      this.products[ind].subtotal = this.products[ind].price * this.products[ind].quantity;

      this.updateTotal();
    },
    changeProductsToSelect(ind, productId) {
      if (ind >= 0) {
        const price = this.getProductsMap[productId].price_with_discount || this.getProductsMap[productId].price;
        this.products[ind].name = this.getProductsMap[productId].name;
        this.products[ind].full_name = this.getProductsMap[productId].name;
        this.products[ind].description = this.getProductsMap[productId].description || "";
        this.products[ind].description_html =
          this.getProductsMap[productId].description_html || this.products[ind].description;
        this.products[ind].unit_of_measure = this.getProductsMap[productId].unit_of_measure || "";
        this.products[ind].quantity = 1;
        this.products[ind].price = price;
        this.products[ind].subtotal = price;
        this.products[ind].attributes = (this.getProductsMap[productId].attributes || []).map((a) => ({
          ...a,
          options: [],
          value: null,
        }));
        this.products[ind].variations = this.getProductsMap[productId].variations || [];
      }

      const productsAvailable = this.getActiveProducts.filter(
        (p) => p.attributes?.length || !this.products.find((pp) => p.id === pp.id),
      );

      let list;
      this.total = 0;

      for (let i = 0; i < this.products.length; i++) {
        list = [...productsAvailable];
        if (this.products[i].id && this.getProductsMap[this.products[i].id])
          list.push(this.getProductsMap[this.products[i].id]);
        else if (this.products[i].id) list.push({ id: this.products[i].id, name: this.products[i].name });
        this.productsToSelect[i] = list;
        this.total += this.products[i].quantity * this.products[i].price;
      }
    },
    removeProduct(ind) {
      this.products.splice(ind, 1);
      this.productsToSelect.splice(ind, 1);
      this.changeProductsToSelect();
    },
    changeAttributeOption(option, productInd, attributeId) {
      const attributeInd = this.products[productInd].attributes.findIndex((a) => a.id === attributeId);
      if (attributeInd >= 0) {
        this.products[productInd].attributes[attributeInd].value = option;
        this.products[productInd].full_name = this.products[productInd].attributes?.length
          ? `${this.products[productInd].name} ${this.products[productInd].attributes
              .filter((a) => a.value)
              .map((a) => a.value.name)
              .join(" - ")}`
          : this.products[productInd].name;

        if (this.products[productInd].variations?.length) {
          this.products[productInd].price = this.getProductVariationPrice(this.products[productInd]);
          this.updateSubtotal(productInd);
        }
      }
    },
    getProductVariationPrice(product) {
      let price = this.getProductsMap[product.id].price;
      let attributes = product.attributes.filter((a) => a.value?.name);

      for (let variation of product.variations) {
        if (variation.attributes_ids.length !== attributes.length) continue;

        let valid = true;

        for (let attributeId in variation.attributes) {
          let attribute = attributes.find((a) => a.id === attributeId);

          if (attribute.value.name !== variation.attributes[attributeId].value && valid) {
            valid = false;
          }
        }

        if (!valid || variation.type === "default") continue;

        if (variation.type === "add") price += variation.price;
        else if (variation.type === "set") price = variation.price;

        break;
      }

      return price;
    },
    async saveTicketProducts() {
      try {
        this.loadingSave = true;

        if (!this.$refs.formProducts.validate()) return;

        await this.setTicketProducts({ id: this.ticketId, products: this.products });
        this.editProducts = false;
      } catch (error) {
        console.error("saveTicketProducts: ", error);
      } finally {
        this.loadingSave = false;
      }
    },
  },
};
</script>
